// Polyfill for includes
if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }
    if (start === undefined) { start = 0; }
    return this.indexOf(search, start) !== -1;
  };
}
//


$(document).ready(function () {

  $('.cookie-banner-content p').html(`We use cookies to offer you a better browsing experience, analyze site traffic, personalize content and serve targeted advertisements. To learn more or change your cookie preferences, choose <em>Manage Cookie Preferences</em>. For further information on the use of cookies and information we collect, visit our <a href="https://www.asmglobal.com/p/other/privacy-policy" target="_blank">Privacy Policy</a>.`);

  // move generalmessage
  if ($('body').hasClass('site-oncenter')) {
    $('.generalmessage').prependTo('#uc_masterPageWidgets');
  } else {
    $('.generalmessage').remove();
  }

  // Header Ticket Link and Directions URL
  if (siteTheme === 'Amphitheater') {
    $('.customTicket').attr('href', 'https://www.ticketmaster.com/st-josephs-health-amphitheater-at-lakeview-tickets-syracuse/venue/1383');
    $('.customDirections').attr('href', 'https://www.asmsyracuse.com/p/amphitheater/guest-services/directions--parking');
  } else {
    $('.customTicket').attr('href', 'https://www.ticketmaster.com/search?radius=10000&sort=date%2Casc&geoHash=dr9u&unit=miles&tab=events&q=the%2Boncenter&daterange=all');
    $('.customDirections').attr('href', 'https://www.asmsyracuse.com/p/visit/directions-parking-oncenter');
  }


  // change favicon for ampthitheater pages
  if (siteTheme === 'Amphitheater') {
    $('link[type="image/x-icon"]').attr('href', `${FULLCLIENTTHEMEPATH}images/favicon-amp.ico`);
  } else {
    $('link[type="image/x-icon"]').attr('href', `${FULLCLIENTTHEMEPATH}images/favicon.ico`);
  }

  // Set Amphitheater homepage content
  if (!$('body').hasClass('amp-homepage')) {
    $('.afterContent').remove();
  } else {
    const ampHomeHTML = $('.afterContent').html();
    $('main.content').html(ampHomeHTML);
  }

  // Header Site Links
  if ($('body').hasClass('site-oncenter')) {
    $('.asm-site-links a').removeClass('site-active');
    $('.asm-site-links__oncenter').addClass('site-active');
  }
  if ($('body').hasClass('site-amphitheater')) {
    $('.asm-site-links a').removeClass('site-active');
    $('.asm-site-links__amphitheater').addClass('site-active');
  }


  // Header Custom Email Signup - open signup modal
  // $('.customEmailSignup').click(function() {
  //   window.top.OpenModal('modal', SITEBASEURL+'modalucloader.aspx?controlpath=~/events/content/email.ascx','600px','275px', { 'OnClosePostBack':false, 'OnCloseTargetID':'Reload', 'Parent': window, 'ScrollFrame': false })
  // });




  // Header Custom Search
  const openSearch = () => {
    $('.asm-site-links').addClass('search-active');
    $('.asm-site-links-wrapper').fadeOut('fast', function () {
      $('.custom-search-wrapper').fadeIn();
      $('.custom-search-wrapper input').focus();
    });
  }

  const closeSearch = () => {
    $('.custom-search-wrapper').fadeOut('fast', function () {
      $('.asm-site-links-wrapper').fadeIn('fast');
    });
    $('.custom-search-submit').val('');
    $('.asm-site-links').removeClass('search-active');
  }

  const submitSearch = () => {
    const val = $('.custom-search-wrapper input').val();
    $('.searchBox .inputFieldTextbox').val(val);
    $('.searchBox .searchSubmitButton').click();
  }

  $('.customSearch').on('click keypress', function (e) {
    if (e.type === 'click' || e.key === 'Enter') {
      openSearch();
    }
  });
  $('.custom-search-submit').on('click keypress', function (e) {
    if (e.type === 'click' || e.key === 'Enter') {
      submitSearch();
    }
  });
  $('.custom-search-close').on('click keypress', function (e) {
    if (e.type === 'click' || e.key === 'Enter') {
      closeSearch();
      $('.customSearch').focus();
    }
  });

  $(window).resize(function () {
    let asmLinksSearch = $('.asm-site-links');
    if (asmLinksSearch.hasClass('search-active')) {
      closeSearch();
    }
  });


  // Site Map heading changes
  const siteMapList = $('.site');
  if (siteMapList.length > 0) {
    siteMapList.find('h2').addClass('sitemap-col-heading').css('opacity', 1);
  }


  // Footer Top SVG Shape
  let footerTop;

  if (siteTheme === 'Amphitheater') {
    footerTop = `
      <svg id="footer-top" viewBox="0 0 1600 284.78">
          <defs>
              <pattern id="amp_footer-top-img" patternUnits="userSpaceOnUse" width="1920" height="400">
                  <image xlink:href="${FULLCLIENTTHEMEPATH}images/footer-top-bg.png" x="0" y="0"/>
              </pattern>
          </defs>
          <path class="amp-ft-1" d="M1600,223.78c-692.67,6.5-1114.67,18.33-1600,61v-3c361-37,1016.17-62,1600-59Z" transform="translate(0 0)" fill="url(#amp_footer-top-img)"/>
          <path class="amp-ft-2" d="M1600,216.71C907.11,221.56,483.33,231.34,0,274.78V0H1600Z" transform="translate(0 0)" fill="url(#amp_footer-top-img)"/>
      </svg>
    `;

    // Footer Logos
    $('.footer-logos__site').attr('src', `${FULLCLIENTTHEMEPATH}images/St-Josephs-Health-Amphitheater-Logo-SingleColorr.svg`);
    $('.footer-logos__sistersite').attr('aria-label', 'Affiliated Venue - The Oncenter');
    $('.footer-logos__sistersite').attr('href', SITEBASEURL);
    $('.footer-logos__sistersite').on('click', function () {
      localStorage.setItem("siteTheme", "Oncenter");
    })
    

    // Footer Contact
    $('.footer-contact__phone').append('<a href="tel:3154355100">315.435.5100</a>');
    $('.footer-contact__address').append('<span>490 Restoration Way, <br>Syracuse, NY 13209</span>');
    $('.footer-contact__email').append('<a href="mailto:info@ASMsyracuse.com">info@ASMsyracuse.com</a>');

  }
  if (siteTheme === 'Oncenter') {
    footerTop = `
      <svg id="footer-top"viewBox="0 0 1600 165">
        <defs>
          <style>.onc-ft-1{fill:#227092;}</style>
        </defs>
        <polyline class="onc-ft-1" points="0 165 0 0 1600 0"/>
      </svg>
    `;

    // Footer Logos
    $('.footer-logos__site').attr('src', `${FULLCLIENTTHEMEPATH}images/onc_footer-logo.png`);
    $('.footer-logos__sistersite').attr('aria-label', "Affiliated Venue - St. Joseph's Health Amphitheater");
    $('.footer-logos__sistersite').attr('href', `${SITEBASEURL}p/amphitheater`);

    // Footer Contact
    $('.footer-contact__phone').append('<a href="tel:3154358000">315.435.8000</a>');
    $('.footer-contact__address').append('<span>800 South State St. <br>Syracuse, NY 13202</span>');
    $('.footer-contact__email').append('<a href="mailto:info@ASMsyracuse.com">info@ASMsyracuse.com</a>');

  }

  $('.footer-top-image').prepend(footerTop);


  // Footer Site Map
  // const footerNav = $('.footerItems1');
  // const footerSiteMap = $('.footer-site-map');
  // const footerNavClone = footerNav.clone();
  // footerNav.remove();
  // console.log(footerNavClone)
  // footerNavClone.each(function() {
  //   let link = $(this).find('a');
  //   link.removeAttr('id');
  //   link.each(function() {
  //     if ($(this).text().toLowerCase().includes('privacy')) {
  //       $(this).attr('href', 'https://asmglobal.com/p/other/privacy-policy');
  //       $(this).attr('target', '_blank');
  //     }
  //   });
  //   footerSiteMap.append(link);
  // });

  // Footer site map stuff
  if (siteTheme === 'Amphitheater') {
    $('.footer-site-map--oncenter').remove();
  } else {
    $('.footer-site-map--amphitheater').remove();
  }

  // Copy footer site map to mobile-nav-footer-links
  $('.mobile-menu-footer-links').html($('.footer-site-map a').clone().slice(5));


  // Footer Email Signup
  // let footerES = $('.footer .emailSignup');
  // footerES.addClass('footer-middle-column');
  // footerES.find('.emailSignupText').html('Sign up for the latest<br> news &amp; promotions');
  // footerES.find('.inputFieldSubmit').text('Submit');


  // Replace "Powered By" logo
  $('.footer .saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffireFooter-logo.png`);


  // Hide specified columns from site map page based on siteTheme
  if ($('.content .site').length) {
    $('.content .site > .left').each(function () {
      // hide amphitheater sitemap links from sitemap if sitetheme is oncenter
      if (siteTheme === 'Oncenter') {
        if ($(this).find('h2').text() === 'Amphitheater') {
          $(this).remove();
        }
      } else {
        // hide oncenter sitemap links from sitemap if sitetheme is amphitheater
        if ($(this).find('h2').text() !== 'Amphitheater') {
          $(this).remove();
        }
        $(this).parent('.site').addClass('amp-sitemap');
      }
    });
  }


  // Remove <br> in breadcrumb text
  $('#MainContent_content_smp_breadcrumbs > .small.bc').each(function () {
    let text = $(this).text();
    if (text.includes('<br>')) {
      $(this).text(text.replace('<br>', '-'));
    }
  });

});


$(window).load(function () {

  // Main Navigation
  if ($('body').hasClass('site-amphitheater')) {
    let $nav = $('#mainNavigation .mainNavigationItem5').clone();
    $('#mainNavigation .group').remove();
    $nav.children('.items').children('.item').each(function (i) {
      let $this = $(this);
      if (!$this.hasClass('navClonedItem')) {
        $this.removeClass('item');
        $this.addClass(`group mainNavigationItem${i}`);
        let a = $this.children('a');
        if (a.text().includes('>')) {
          let t = a.text().slice(0, -1);
          a.text(t.trim());
        } else {
          a.text(a.text().trim());
        }
        $this.children('.subitems').addClass('items');
        $this.children('.subitems').removeClass('subitems');
        $this.appendTo('#mainNavigation .groups');
      }
    });
  }
  if ($('body').hasClass('site-oncenter')) {
    $('#mainNavigation .mainNavigationItem5').remove();
  }



  // append logo to navbar
  let logoImg;

  if (siteTheme === 'Amphitheater') {
    logoImg = `
      <a href="${SITEBASEURL}p/amphitheater" class="main-logo" aria-label="St. Josephs Health Amphitheater">
        <img src="${FULLCLIENTTHEMEPATH}images/St-Josephs-Health-Amphitheater-Logo-Colorr.svg" alt="St. Josephs Health Amphitheater">
      </a>
    `;
    // also set mobile header logo url
    $('.header-logo').attr('href', `${SITEBASEURL}p/amphitheater`);
  }
  if (siteTheme === 'Oncenter') {
    logoImg = `
      <a href="/" class="main-logo" aria-label="The Oncenter">
        <img src="${FULLCLIENTTHEMEPATH}images/logo-ONCENTER-tagline.svg" alt="The Oncenter">
      </a>
    `;
  }

  $(`<li class="logo-nav-item">${logoImg}</li>`).insertAfter('#mainNavigation .mainNavigationItem2');

});